import { cloneDeep } from "lodash";
import { Reducer } from "redux";
import { updateObject } from "src/shared/updateObject";
import * as actionTypes from "src/store//actions/actionTypes";
import {
  IDisablePullToRefreshAction,
  IGetBounceAction,
  ISetActiveBreakpoint,
  IStateUI,
  IToggleSideDrawerAction,
  IToggleSoundAction,
  IVideoIsLoadedAction
} from "src/store/StoreInterface";

const initialState: IStateUI = {
  bounce: false,
  breakpoint: {},
  muted: true,
  pullToRefreshDisabled: false,
  showSideDrawer: false,
  videoLoaded: false
};

const disablePullToRefresh = (
  state: IStateUI,
  action: IDisablePullToRefreshAction
) => {
  return updateObject(state, {
    pullToRefreshDisabled: action.payload
  });
};

const getBounce = (state: IStateUI, action: IGetBounceAction) => {
  return updateObject(state, {
    bounce: action.payload
  });
};

const setActiveBreakpoint = (state: IStateUI, action: ISetActiveBreakpoint) => {
  const newData = cloneDeep(action.payload);
  return updateObject(state, {
    breakpoint: newData
  });
};

const toggleSideDrawer = (state: IStateUI, action: IToggleSideDrawerAction) => {
  return updateObject(state, {
    showSideDrawer: action.payload
  });
};

const toggleSound = (state: IStateUI, action: IToggleSoundAction) => {
  return updateObject(state, {
    muted: action.payload
  });
};

const videoIsLoaded = (state: IStateUI, action: IVideoIsLoadedAction) => {
  return updateObject(state, {
    videoLoaded: action.payload
  });
};

const reducer: Reducer = (
  state: IStateUI = initialState,
  action:
    | IDisablePullToRefreshAction
    | IGetBounceAction
    | ISetActiveBreakpoint
    | IToggleSideDrawerAction
    | IToggleSoundAction
    | IVideoIsLoadedAction
) => {
  switch (action.type) {
    case actionTypes.DISABLE_PULL_TO_REFRESH:
      return disablePullToRefresh(state, action);
    case actionTypes.GET_BOUNCE:
      return getBounce(state, action);
    case actionTypes.SET_ACTIVE_BREAKPOINT:
      return setActiveBreakpoint(state, action);
    case actionTypes.TOGGLE_SIDEDRAWER:
      return toggleSideDrawer(state, action);
    case actionTypes.TOGGLE_SOUND:
      return toggleSound(state, action);
    case actionTypes.VIDEO_IS_LOADED:
      return videoIsLoaded(state, action);
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/ui.tsx